module.exports = __webpack_public_path__ + "noNotifications.png";